var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "json-nested-viewer",
      class: { "json-nested-viewer--compact": _vm.compact }
    },
    [
      _vm.isEmpty
        ? _c("div", { staticClass: "json-nested-empty" }, [
            _vm._v(_vm._s(_vm.emptyText))
          ])
        : _c("json-nested-block", {
            attrs: {
              value: _vm.displayValue,
              depth: 0,
              compact: _vm.compact,
              "field-labels": _vm.mergedFieldLabels,
              "max-nested-table-height": _vm.maxHeight
            }
          })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }